import DataTable, { TableProps } from 'react-data-table-component'
import { Tr } from '../../_metronic/i18n/Tr'

/**
 * Wrapper around react-data-table-component that translates the strings the
 * library renders itself (the empty state), which otherwise stay in English
 * when the user switches language.
 */
function AppDataTable<T>(props: TableProps<T>) {
  const t = Tr()

  return (
    <DataTable
      noDataComponent={<div className='p-4'>{t('There are no records to display')}</div>}
      {...props}
    />
  )
}

export default AppDataTable
